import { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Problem from './components/Problem';
import Consequences from './components/Consequences';
import Solution from './components/Solution';
import Benefits from './components/Benefits';
import FAQ from './components/FAQ';
import About from './components/About';
import Contact from './components/Contact';
import CTA from './components/CTA';
import Footer from './components/Footer';
import SEO from '../../components/SEO';

export default function Home() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <SEO />
      <Navbar isScrolled={isScrolled} />
      <Hero />
      <Problem />
      <Consequences />
      <Solution />
      <Benefits />
      <FAQ />
      <About />
      <Contact />
      <CTA />
      <Footer />
    </div>
  );
}